module.exports = __webpack_public_path__ + "static/07_sunscreen_calculator.8a53686d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/07_sunscreen_calculator.jpg
// module id = 516
// module chunks = 111663361672460